import { connect } from 'react-redux';
import actions from 'actions/InCall/InCallVideo';
import { VIDEO_SECONDARY } from 'constants/InCall/InCallVideo';
import { popoutPresentationSelector, popoutPresentationFeatureSelector } from 'selectors/call';
import PopoutButton from 'components/InCall/PopoutButton/PopoutButton';
import _get from 'lodash/get';

const mapActionCreators = dispatch => ({
  togglePopout: toggle => dispatch(actions.togglePopout(toggle)),
});

export const presentationItemHeight = 48;
export const minPresentationCornerHeight = 148;

const mapStateToProps = (state, ownProps) => {
  const popoutPresentationFeature = popoutPresentationFeatureSelector(state);
  const videoLayout = _get(state, 'app.inCallVideo.videoLayout');
  const popoutPresentation = popoutPresentationSelector(state);
  const presentationWidth = _get(videoLayout, ['videos', VIDEO_SECONDARY, 'width']) || 0;
  const presentationRatio = _get(videoLayout, ['videos', VIDEO_SECONDARY, 'ratio']) || 1;
  const presentationHeight = (presentationWidth / presentationRatio) - presentationItemHeight;
  const isInMiddle = presentationHeight < minPresentationCornerHeight;
  const tooSmallForIcon = presentationHeight < (presentationItemHeight / 2);
  const isDragging = _get(state, 'app.inCallVideo.isDragging');

  const hidePopout = !popoutPresentationFeature ||
    !ownProps.isVisible ||
    tooSmallForIcon ||
    isDragging;

  const position = {
    height: presentationHeight + presentationItemHeight,
    width: presentationWidth
  };

  return ({
    popoutPresentation,
    position,
    hidePopout,
    isInMiddle
  });
};

export default connect(mapStateToProps, mapActionCreators)(PopoutButton);
